import { Builder } from '@builder.io/react'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import LinkRoute from '../../../ui/link/Link'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  textOne: string
  url: string
  textAlignment: Alignment
}

const BlogBackButton = ({ backgroundColor, textOne, url, textAlignment }: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div className={`flex flex-col w-full items-start justify-start px-[1.25rem]`}>
      <div className={`${textAlignClass}`} style={{ backgroundColor: backgroundColor }}>
        {textOne && (
          <LinkRoute
            href={url}
            className="z-2 rounded-full hover:underline focus:underline flex justify-center items-center text-[#006685] font-medium text-base"
          >
            <FontAwesomeIcon icon={faChevronLeft} className="h-4 w-4 mr-2" aria-hidden="true" /> {textOne}{' '}
          </LinkRoute>
        )}
      </div>
    </div>
  )
}

export default BlogBackButton

Builder.registerComponent(BlogBackButton, {
  name: 'BlogBackButton',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'textOne',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'url',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    }
  ]
})
